export default __webpack_public_path__ + "static/media/swap-arrow-icon.58c86310.svg";